export default {"src":"/_next/static/media/shellfish.2063657d.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};